import { Component, Input, HostListener } from '@angular/core'

@Component({
	selector: 'app-image-gallery',
	templateUrl: './image-gallery.component.html',
	styleUrls: ['./image-gallery.component.scss']
})
export class ImageGalleryComponent {
	@Input() images: string[] = []
	@Input() loading = false
	@Input() skeletonCount = 4
	@Input() emptyIcon = 'fa-solid fa-images'
	@Input() emptyTitle = 'Sin fotografías'
	@Input() emptyDescription = ''
	@Input() columns = 4

	selectedImage: string | null = null
	lightboxVisible = false
	currentIndex = 0
	imageLoadState = new Map<string, 'loading' | 'loaded' | 'error'>()

	get gridStyle() {
		return { 'grid-template-columns': `repeat(${this.columns}, 1fr)` }
	}

	get skeletons(): number[] {
		return Array(this.skeletonCount).fill(0)
	}

	trackByUrl(_index: number, url: string): string {
		return url
	}

	getImageState(url: string): string {
		return this.imageLoadState.get(url) || 'loading'
	}

	onImageLoad(url: string): void {
		this.imageLoadState.set(url, 'loaded')
	}

	onImageError(url: string): void {
		this.imageLoadState.set(url, 'error')
	}

	openLightbox(url: string): void {
		this.currentIndex = this.images.indexOf(url)
		this.selectedImage = url
		this.lightboxVisible = true
	}

	closeLightbox(): void {
		this.lightboxVisible = false
		this.selectedImage = null
	}

	navigateImage(direction: 1 | -1): void {
		if (!this.images.length) return
		this.currentIndex = (this.currentIndex + direction + this.images.length) % this.images.length
		this.selectedImage = this.images[this.currentIndex]
	}

	@HostListener('document:keydown', ['$event'])
	onKeydown(event: KeyboardEvent): void {
		if (!this.selectedImage) return
		if (event.key === 'ArrowLeft') this.navigateImage(-1)
		if (event.key === 'ArrowRight') this.navigateImage(1)
		if (event.key === 'Escape') this.closeLightbox()
	}
}
